var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngelDoubleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0439 11.6489L10.6985 11.9992L11.043 12.3502L18.9555 20.4127L18.9555 20.4127L18.9588 20.416C19.0951 20.5523 19.1008 20.7493 18.976 20.8906C18.8744 20.9666 18.7991 20.9875 18.7124 20.9875C18.6439 20.9875 18.5413 20.9461 18.4672 20.8726C18.4668 20.8722 18.4664 20.8718 18.466 20.8714L9.99404 12.2495L9.99406 12.2495L9.99096 12.2464C9.84872 12.1042 9.84872 11.8958 9.99096 11.7535L9.99097 11.7535L9.99404 11.7504L18.4672 3.1273C18.6094 2.98629 18.817 2.9867 18.9588 3.12853C19.1011 3.27077 19.1011 3.47918 18.9588 3.62142L18.9564 3.62393L11.0439 11.6489Z",
    stroke: "inherit",
    fill: "none",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5249 12L14.4374 3.97498C14.7749 3.63748 14.7749 3.11248 14.4374 2.77498C14.0999 2.43748 13.5749 2.43748 13.2374 2.77498L4.7624 11.4C4.4249 11.7375 4.4249 12.2625 4.7624 12.6L13.2374 21.225C13.3874 21.375 13.6124 21.4875 13.8374 21.4875C14.0624 21.4875 14.2499 21.4125 14.4374 21.2625C14.7749 20.925 14.7749 20.4 14.4374 20.0625L6.5249 12Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelDoubleLeft);
export default __webpack_public_path__ + "static/media/angel-double-left.6bfb9c3a28e729bafc0e503ab9113d9e.svg";
export { ForwardRef as ReactComponent };